import SimCardAlertIcon from '@mui/icons-material/SimCardAlert';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Appointment } from '@work4all/models/lib/Classes/Appointment.entity';
import { AppointmentBillableStatus } from '@work4all/models/lib/Enums/AppointmentBillableStatus.enum';

import { Tooltip } from '../tooltip/Tooltip';

export interface BillableApppointmentIconProps {
  appointment: Appointment;
  size?: 'large' | 'medium' | 'small';
  className?: string;
}

export function BillableApppointmentIcon(props: BillableApppointmentIconProps) {
  const { appointment, size = 'medium', className } = props;

  const { t } = useTranslation();
  const isBillable =
    appointment?.details?.billableStatus === AppointmentBillableStatus.BILLABLE;

  return isBillable ? (
    <Stack alignItems="center" className={className}>
      <Tooltip title={t('APPOINTMENT.BILLABLE_TERMIN_INFO')}>
        <SimCardAlertIcon
          color="error"
          fontSize={size}
          // The calendar adds its events handling layer to the elements,
          // but we want to have this icon and popup always available
          onMouseEnter={(e) => e.stopPropagation()}
          onMouseLeave={(e) => e.stopPropagation()}
        />
      </Tooltip>
    </Stack>
  ) : null;
}
